import { Container, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setMessage } from '../toasts/toastSlice';
import { setOrdersModalConfig } from './orderSlice';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPES } from '../../config/consts/commons';
import BarcodeScannerFull from '../common/components/barcodeScanner/BarcodeScannerFull';

function BarcodeScannerViewer({ onClose }) {
  const { t } = useTranslation(['system', 'description', 'title']);
  const { orderQR } = useSelector((state) => state.orders);

  const dispatch = useDispatch();

  const handleBarcodeDetected = async (code) => {
    const scannedCode = typeof code === 'string' ? code : code?.text || '';

    const scanLink = new URL(scannedCode);
    const id_order = scanLink.searchParams.get('data');

    if (Number(orderQR?.id_order) === Number(id_order)) {
      dispatch(
        setMessage({
          body: t('SUCCESS_ORDER_CONFIRM', {
            ns: 'system',
            order: orderQR?.id_order,
          }),
          type: NOTIFICATION_TYPES.SUCCESS,
        })
      );
      dispatch(
        setOrdersModalConfig({
          titleOpening: t('orders.deliver.modal.wish_deliver_order', {
            ns: 'description',
          }),
          show: true,
          order: { ...orderQR },
          modalType: 'toDeliver',
        })
      );

      onClose();
    } else {
      dispatch(
        setMessage({
          body: t('QR_ERROR_VALIDATION_ORDER_WITH_VALUE', {
            ns: 'system',
            code: scannedCode,
          }),
          type: NOTIFICATION_TYPES.ERROR,
        })
      );
    }

    onClose();
  };

  return (
    <Container maxWidth="sm">
      <Typography
        component="h1"
        variant="h4"
        mt={4}
        mb={2}
        sx={{ fontWeight: 'bold' }}
      >
        {t('barcode_code', { ns: 'title' })}
      </Typography>

      <Typography component="p" variant="body1" mb={4}>
        {t('barcode_code_label', { ns: 'description' })}
      </Typography>

      <BarcodeScannerFull onDetected={handleBarcodeDetected} />
    </Container>
  );
}

export default BarcodeScannerViewer;
